// extracted by mini-css-extract-plugin
module.exports = {"block":"part6_block__2_-Th","top":"part6_top__E90g6","inner":"part6_inner__3uDcF","item":"part6_item__18SnC","img":"part6_img__19GUn"};